import { FolderOutlined, GiftOutlined, LineChartOutlined, PartitionOutlined, SyncOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { PERMISSIONS } from 'modules/permission';
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const contents: NavItemType = {
  id: 'contents',
  title: <FormattedMessage id="contents" />,
  type: 'group',
  permission: PERMISSIONS.PRODUCTS.READ | PERMISSIONS.CATEGORIES.READ,
  children: [
    {
      id: 'categories-new',
      title: <FormattedMessage id="categories" />,
      type: 'item',
      url: '/contents/categories',
      icon: FolderOutlined,
      permission: PERMISSIONS.CATEGORIES.READ
    },
    {
      id: 'subcategories',
      title: <FormattedMessage id="subcategories" />,
      type: 'item',
      url: '/contents/subcategories',
      icon: PartitionOutlined,
      permission: PERMISSIONS.CATEGORIES.READ
    },
    {
      id: 'products',
      title: <FormattedMessage id="products" />,
      type: 'item',
      url: '/contents/products',
      icon: GiftOutlined,
      permission: PERMISSIONS.PRODUCTS.READ
    },
    {
      id: 'partner-trackings',
      title: <FormattedMessage id="partner-trackings" />,
      type: 'item',
      url: '/contents/partner-trackings',
      icon: LineChartOutlined,
      permission: PERMISSIONS.PRODUCTS.READ
    },
    {
      id: 'categoriessync',
      title: <FormattedMessage id="categoriessync" />,
      type: 'item',
      url: '/contents/categories-sync',
      icon: SyncOutlined,
      permission: PERMISSIONS.CATEGORIES.MANAGE
    }
  ]
};

export default contents;
